// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3mlG8","rootNoMargin":"styles_rootNoMargin__1Ky1N"};